export function getFullOffset(element: HTMLElement) {
    let elementToLoop: HTMLElement = element;
    let totalOffset = 0;
    while (elementToLoop && elementToLoop !== undefined) {
      totalOffset += elementToLoop.offsetTop;
      elementToLoop = elementToLoop.offsetParent as HTMLElement;
    }
    return totalOffset;
  }